import React from "react"
import BasicHero from "../../components/basic-hero"
import CTARow from "../../components/cta-row"
import { HandleImages } from "../../components/functions"
import Layout from "../../components/layout"
import LearnInfo from "../../components/learn-infographic"
import Resource from "../../components/resource"
import ResourcesWrapper from "../../components/resources-wrapper"
import SEO from "../../components/seo"
import { seodata } from "../../components/seo-data"
import SimpleSlide from "../../components/simple-slide"
import SimpleSlider from "../../components/simple-slider"
import SocialSlider from "../../components/social-slider"
import Products from "../../components/store-products"





var image;
var content = {
  hero: {
    title: (
      <span>
 Learn Cyber Security<br/>

with Project Ares
      </span>
    ),
    text:<span>
      <h4 style={{margin:"0 0 .5em 0"}}>Are you a student preparing for your first job?</h4>
      <h4 style={{margin:"0 0 .5em 0"}}>Changing careers?</h4>
      <h4 style={{margin:"0 0 .5em 0"}}>Are you intrigued by the field of cyber security and looking to dive deeper into a professional practice?</h4>
    <p>You've come to the right place!</p>
    <p>With remote work more commonplace and cyber jobs in demand, Circadence’s Project Ares platform can help you kickstart your career in cyber.</p>
   </span>,
  },

 

  cta1:{
    title:"Kickstarting a cyber security career",
    text:"We sat down with Dr. Dan Manson of Cal Poly Pomona to learn more about resources that help cyber students gain experience and skills in the industry.",
    url:"https://marketing.circadence.com/acton/media/36273/webinar-kickstarting-a-cyber-career-2019-11",
    cta:"Watch Webinar"
  },
  social:{
    social1:{
      image:"",
      title:"",
      text:<span>It provides tangible experience and solidifies concepts learned in class.<br/> <br/> It gave me confidence being able to implement these skills, which I think would be extremely valuable for students in the future.<br/><span className="source">- Student User from University of San Diego</span></span>,
      url:"/teach"
    }
  },
 //URL NEEDS UPDATE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  resources:{
    resource1:{
      
      title:<span>The Benefits of Gamified Learning<span>Infographic</span></span>,
      text:"Check out what gamification is and how it’s used to help cyber ‘newbies’ and seasoned pros alike, build skills.",
      url:"https://staging.circadence.com/wp-content/uploads/2019/03/Gamification-Infographic.pdf"
    },
    resource2:{
     
      title:<span> Top 10 Cyber Security Myths<span>Infographic </span></span>,
      text:"Brush up on these pervasive myths permeating the cyber industry today. Learn them so you don’t fall victim to them when it comes time to enter into the field.   ",
      url:"https://staging.circadence.com/wp-content/uploads/2019/06/Cyber-Myths-Infographic-FINAL.pdf"
    },
    resource3:{
      
      title:<span> How Gamified Learning Helps Build Cyber Skills<span>Infographic</span></span>,
      text:"Learn the current landscape of cyber security and how continual training with gamification can help in your pursuit of the cyber career or position ",
      url:"https://staging.circadence.com/wp-content/uploads/2019/08/gamification-and-AI-infographic_FINAL.pdf"
    }, 
  },
  simple:{
    simple1:{
      text:"Prepare for cyber security certifications with hands on practice.",
    },
    simple2:{
      text:"Build professional credentials through NICE Cybersecurity Workforce Framework inspired learning paths.",
    },
    simple3:{
      text:"Train on your schedule from any location  with browser-based access.",
    },
    simple4:{
      text:"Learning is relevant as you build skills in single and multi-player exercises that are inspired by real-life cyber incidences.",
    },
    simple5:{
      text:"Global chat feature creates a ‘community’ of cyber enthusiasts—just like you!",
    },
  }
}
 
 
class LearnPage extends React.Component {
  render() {
    return (
      <Layout> <SEO title={seodata.learn.title} description={seodata.learn.description} keywords={seodata.learn.keywords} />
        <BasicHero
          title={content.hero.title}
          text={content.hero.text}
          image={<HandleImages name={'womanLaptop'}/>}
        />
     
     <LearnInfo/>
        <CTARow title={content.cta1.title} text={content.cta1.text} cta={content.cta1.cta} url={content.cta1.url} inv={false} bgColor={"deep-blue"} image={'laptop'}/>
        

                
        <SocialSlider>
    <SimpleSlide   image={<HandleImages name={'womanCouch'}/>} text={content.social.social1.text} />
   
 

        </SocialSlider>



        <h3>Additional Resources </h3>

        <ResourcesWrapper>
        <Resource  image={<HandleImages name={'gamification'}/>} title={content.resources.resource1.title} text={content.resources.resource1.text} url={content.resources.resource1.url}/>
        <Resource  image={<HandleImages name={'manLaptop'}/>} title={content.resources.resource2.title} text={content.resources.resource2.text} url={content.resources.resource2.url}/>
        <Resource  image={<HandleImages name={'manWomanComputer'}/>} title={content.resources.resource3.title} text={content.resources.resource3.text} url={content.resources.resource3.url}/>
       
        </ResourcesWrapper>



        <SimpleSlider>
    <SimpleSlide   image={<HandleImages name={'pAScreen1'}/>} text={content.simple.simple1.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen2'}/>} text={content.simple.simple2.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen3'}/>} text={content.simple.simple3.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen4'}/>} text={content.simple.simple4.text} />
    <SimpleSlide   image={<HandleImages name={'pAScreen5'}/>} text={content.simple.simple5.text} />

        </SimpleSlider>
        <br id='learn-store'/>
        <br/>
     <Products licenses='individual'/>
 
      </Layout>
    )
  }
}

export default LearnPage
